import type { ReactNode } from 'react';
import { createSeoManager, SeoContext, type SeoManager } from '../src/seo/context';
import '../src/index.css';

interface PageShellProps {
  children: ReactNode;
  seoManager?: SeoManager;
}

const defaultSeoManager = createSeoManager();

export function PageShell({ children, seoManager }: PageShellProps) {
  return <SeoContext.Provider value={seoManager ?? defaultSeoManager}>{children}</SeoContext.Provider>;
}
